<!-- PAGE TITLE
        ================================================== -->
<section class="bg-light-red page-title-section top-position1 bg-img cover-background left-overlay-secondary">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <div class="position-relative">
                        <h1>Director's Profile </h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- Director's Profile
        ================================================== -->
<section class="bg-light-color" *ngIf="profile">
    <div class="container">

        <div class="row">
            <div class="col-lg-3 wow fadeInUp" data-wow-delay="200ms">
                <div class="card card-style-07 border-0 bg-transparent">
                    <div class="image ">
                        <a href="#"><img [src]="contentImg(profile.Image)" [alt]="profile.Name" /></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-9 ps-lg-5 mt-5 mt-lg-0 wow fadeInUp" data-wow-delay="400ms">
                <div class="section-title left mb-3">
                    <span class="sm-title">Red Monk Wellness Pvt Ltd </span>
                    <h2 class="display-16 lh-1 mb-2">{{ profile.Name }}</h2>
                    <p class="para" *ngIf="profile.Designation">{{ profile.Designation }}</p>
                    <div class="line"></div>
                </div>

                <div class="">
                    <h5 class="mb-2" *ngIf="profile.Headline">{{ profile.Headline }}</h5>
                    <p class="mb-2" *ngFor="let t of paragraphs(profile.Description)">{{ t }}</p>
                </div>
            </div>

            <div class="col-lg-12 mt-4 wow fadeInUp" data-wow-delay="400ms" *ngIf="profile.MoreHeadline || profile.MoreDescription">
                <div class="mb-0 pb-0 border-0 wow fadeInUp" data-wow-delay="200ms">
                    <h5 class="mb-2" *ngIf="profile.MoreHeadline">{{ profile.MoreHeadline }}</h5>
                    <p class="mb-4" *ngFor="let t of paragraphs(profile.MoreDescription)">{{ t }}</p>
                </div>
            </div>
        </div>

    </div>
</section>